module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h3', [_vm._v("Namen Finder")]), _vm._v(" "), _c('p', [_vm._v("\n    Wie findet man einen Namen?\n  ")]), _vm._v(" "), _c('h5', [_vm._v("\n    Wie heißt du?\n  ")]), _vm._v(" "), (_vm.userNameAvailable && !_vm.modUser) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n          " + _vm._s(_vm.greeting) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": _vm.toggleUserEdit
    }
  }, [_vm._v("Wechseln")])])])]) : _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('form', {
    staticClass: "column col-8",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userName),
      expression: "userName"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.greeting
    },
    domProps: {
      "value": (_vm.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary input-group-btn",
    on: {
      "click": _vm.setUserName
    }
  }, [_vm._v("Name festlegen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.userNameAvailable) ? _c('div', {
    staticClass: "onlyUser"
  }, [_c('h5', [_vm._v("\n      Bewerte Namen:\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: [_vm.userNameAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.move({
          name: 'Names',
          params: {
            visibility: 'favorite'
          }
        })
      }
    }
  }, [_vm._v("\n              Start\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column col-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n            Favoriten\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-136e7804"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 117
// module chunks = 1